import { type CartValue, cartUpdateQuantity } from '@ecomm/data-simplisafe-api'
import { getCartId } from '@ecomm/data-storage'
import { voidFn } from '@simplisafe/ewok'
import * as E from 'fp-ts/lib/Either'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import { useCallback } from 'react'

import { useSetCart } from '../atoms/useCart'

/**
 * Updates the quantity of a line item in the cart.
 */
export const useCartUpdateQuantity = (
  lineItemId: string,
  variationId: string
) => {
  const cartId = getCartId()
  const setCart = useSetCart()

  return useCallback(
    (quantity: number, successFn: (t: CartValue) => void) => {
      const fn = async (id: string) => {
        setCart(['set_cart_updating'])
        const cart = await cartUpdateQuantity(
          id,
          lineItemId,
          quantity,
          variationId
        )()
        pipe(
          cart,
          E.fold(
            err => setCart(['set_cart_error', err]),
            t => {
              setCart(['update_cart', t])
              successFn(t)
            }
          )
        )
      }
      pipe(
        O.fromNullable(cartId),
        O.chain(_cartId => (quantity > 0 ? O.some(_cartId) : O.none)),
        O.fold(() => voidFn(), fn)
      )
    },
    [cartId, setCart, lineItemId, variationId]
  )
}
